//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from 'axios'

export default {
    layout: 'kanax',

    data(){ return {
        id: null,
        showPromoted: false,
        loadingError: 0,
        data: null,
    }},

    metaInfo(){ return {
        // title: 'Series of KanaX',
        link: [
            { rel: 'canonical', href: window.location.href }
        ],
        meta: this.$rm.getMeta(this), //this.$route.meta
    }},

    mounted(){
        // this.load()
    },

    computed: {

    },

    methods: {
        load(){
            console.log('reloading triggered..')
        }
    },

    beforeRouteEnter(to, from, next){
        let id = to.params.series ? to.params.series : ''

        axios.get('/api/ytm/v1/series/' + id)
             .then( ({ data })=>  {
                  next( vm => {
                      vm.data = data.response
                      //
                      if(data.response.channelTitle)
                      vm.title = data.response.channelTitle
                  })
              })
             .catch( e => {
                  console.log(e)
                  next(vm => {
                      vm.loadingError = true
                  })
             })
    }
}
